export default "__VITE_ASSET__DLsAQZCc__"